import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import type { EventWithCircuit } from '../../api/eventsService';
import { isEventActive } from '../../utils/eventSource';
import type { MapTileProvider } from './useNowcastingState';

dayjs.extend(utc);
dayjs.extend(timezone);

/** Max days after event end that Tomorrow.io map tiles may be fetched (observations-disabled fallback). */
export const TIO_MAP_TILE_MAX_DAYS_AFTER_EVENT_END = 14;

export function daysSinceEventEnded(event: EventWithCircuit): number {
  const tz = event.circuit?.time_zone || 'UTC';
  const endDate = dayjs(event.end_date).tz(tz).endOf('day');
  const now = dayjs().tz(tz);
  return now.diff(endDate, 'day');
}

/** Whether Tomorrow.io raster map overlays may be loaded for this event. */
export function isTioMapProviderSupported(selectedEvent: EventWithCircuit | null): boolean {
  if (!selectedEvent) {
    return false;
  }
  if (isEventActive(selectedEvent)) {
    return true;
  }
  return daysSinceEventEnded(selectedEvent) <= TIO_MAP_TILE_MAX_DAYS_AFTER_EVENT_END;
}

/** Default map overlay when an event loads or observations are disabled. */
export function mapTileProviderForObservationsState(
  selectedEvent: EventWithCircuit | null,
  observationsEnabled: boolean,
): MapTileProvider {
  if (observationsEnabled) {
    return 'radar-l2';
  }
  return isTioMapProviderSupported(selectedEvent) ? 'tomorrow.io' : 'radar-l2';
}
